import React from 'react';
import styled from 'styled-components';

interface IInputProps {
    id: string;
    value: string;
    setValue: (value: string) => void;
    hasError?: boolean;
    disabled?: boolean;
}

const Input = styled.input`
    width: ${props => props.styles?.width || '120px'};
    height: ${props => props.styles?.height || '40px'};
    padding: 4px 8px;
    font-size: 15px;
    border: 2px solid
        ${props => (props.hasError ? ({ theme }) => theme.dangerLight : ({ theme }) => theme.baseBackgroundColor)};
    border-radius: 2px;
    outline: none;

    &:focus {
        border-color: ${props => (props.hasError ? ({ theme }) => theme.dangerMain : ({ theme }) => theme.successDark)};
        box-shadow: 0 0 5px
            ${props => (props.hasError ? ({ theme }) => theme.dangerLighter : ({ theme }) => theme.primaryMain)};
    }
`;

const NumberInput: React.FC<IInputProps> = ({ id, value, setValue, hasError, disabled = false }) => {
    return <Input id={id} data-testid={id} value={value} onChange={e => setValue(e.target.value)} hasError={hasError} disabled={disabled} />;
};

export default NumberInput;
